<template>
  <div>
  </div>
</template>

<script>
export default {
  props: {
  },
  data () {
    return {
      debug: location.href.indexOf('localhost') > -1,
      params: {} // data data attached to the field
    };
  },
  methods: {
    reload () {
      location.reload();
    },
    saveDataToContentful (json) {
      // console.log(json);
      this.$extension.field.setValue(json || this.params).then(data => {
        console.log('saved field data to contentful!');
      }).catch(err => {
        console.error('could not save field data to contentful ->', err.message);
      });
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.$extension.window.startAutoResizer();
  },
  beforeDestroy () {
    this.$extension.window.stopAutoResizer();
  },
  components: {
  }
};
</script>

<style lang="scss" scoped>
</style>
